module.exports = __webpack_public_path__ + "static/media/ashes2.69f18664.png";